var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-loading" },
    [
      _c(
        "transition",
        { attrs: { name: "fade", appear: "" } },
        [
          _c("spinner", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show,
                expression: "show",
              },
            ],
            attrs: {
              radius: _vm.spinnerSize,
              thickness: _vm.spinnerThickness,
              color: _vm.spinnerColor,
              speed: _vm.spinnerSpeed,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }